import { TweenLite, Power1, TweenMax } from 'gsap';
import {ANIMATION_TIMEOUT_MODAL} from '../../constants/animation';

const handleComplete = target =>
  TweenLite.set(target, {
    clearProps: 'y, transform',
  });
/**
 * What is a node? It is a DOM element.
 * ex: ref={(node) => {
 *        this.node = node
 *        handleAnimation(node)
 *     }}
 * GSAP doesn't care when or where you call it. It only cares about
 * which DOM elements are animating and their before and after
 * CSS properties.
 */
export const handleEnterAnimation = node => {
  if (!node) return;
  // Cancel existing animations
  TweenMax.killTweensOf(node);
  // Set element initial styles
  TweenLite.set(node, {
    scale: 0.9,
    y: 15,
    ease: Power1.easeIn,
  });
  // Animate element
  TweenLite.to(node, ANIMATION_TIMEOUT_MODAL, {
    force3D: true,
    scale: 1,
    y: 0,
    onComplete: handleComplete, // Fire this when animation finishes
    onCompleteParams: [node],
  });
};
export const handleExitAnimation = node => {
  if (!node) return;
  // Cancel existing animations
  TweenMax.killTweensOf(node);
  // Animate element
  TweenLite.to(node, ANIMATION_TIMEOUT_MODAL, {
    force3D: true,
    scale: 0,
    opacity: 0,
    y: -50,
    ease: Power1.easeIn,
    // onComplete: () => console.log('Page exit complete.'),
  });
};
